<div class="MainContainer">
  <div class="modalContent">
    <div class="d-flex flex-wrap">
      <div class="container">
        <div class="row">
          <div class="col-sm-5">
            <div class="leftContent">
              <app-contents [item]="CurrentItem"> </app-contents>
            </div>
          </div>
          <div class="col-sm-7">
            <div class="formPanel">
              <div class="title">

                <h4>Supplier Registration</h4>
                <h4>Tell us about your company</h4>
                <p>Set up a profile that will help buyers looking for supplier just like you. Provide details and accurate
                  information. This is your opportunity to showcase your company to buyers.</p>
              </div>

              <div class="contentTab">
                <div class="form-content">
                  <!--form section  -->
                  <form>
                    <h2 class="title">Company Information</h2>
                    <div class="row row-sm">
                      <div class="col-sm-6 col-md-3">
                        <div class="form-group">
                          <label class="form-label" for="">Company Name<span class="req">*</span></label>
                          <input class="form-control" readonly  type="text">
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <div class="form-group">
                          <label class="form-label" for="">Country <span class="req">*</span></label>
                          <input class="form-control" readonly  type="text">
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <div class="form-group">
                          <label class="form-label" for="">State <span class="req">*</span>
                          </label>
                          <input class="form-control" readonly  type="text">
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <div class="form-group">
                          <label class="form-label" for="">City <span class="req">*</span></label>
                          <input class="form-control" readonly  type="text">
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-9">
                        <div class="form-group">
                          <label class="form-label" for="">Address<span class="req">*</span></label>
                          <input class="form-control" name="address" >
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-3">
                        <div class="form-group">
                          <label class="form-label" for="">Zip Code<span class="req">*</span></label>
                          <input class="form-control" name="zipCode"  maxlength="10" minlength="5" type="text" >
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <div class="form-group">
                          <label class="form-label" for="">DNB Code <span class="req">*</span></label>
                          <input class="form-control" name="dnbCode" placeholder="Enter DNB Code" maxlength="30">
                          
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <div class="form-group">
                          <label class="form-label" for="">Consultant Count<span class="req">*</span></label>
                          <input type="text" class="form-control"  name="consultantCount" placeholder="Enter Consultant Count">
                          </div>
                        </div>
                      </div>
               

                      <div class="divider"></div>
                      <h4><b>
                      <a target="_blank">Terms & Conditions</a></b></h4>
                      <div class="mt-4">
                        <input type="checkbox" name="terms" value="" />&nbsp;
                        <label for="term">I have read this conditions</label><br>
                      </div>
                      <div class="d-flex justify-content-center mt-3 mb-2">
                        <!-- Tooltip Wrapper -->
                        <span matTooltip="Accept the terms to enable this button" matTooltipPosition="above">
                          <button class="btn btn-primary mx-2" type="button">Submit</button>
                        </span>
                      </div>
                  </form>
                </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
